(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/javascripts/pay/track-payment.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/javascripts/pay/track-payment.js');

'use strict';

const _excluded = ["wager"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  format
} = svs.utils;
const {
  productMapping
} = svs.numbergames;
function formatItems(bets) {
  const items = [];
  bets.forEach(bet => {
    const item = {
      productId: bet.productId,
      productName: productMapping.getProductDayName(bet.productId),
      price: format.CurrencyFromJupiterString(bet.betAmountSalesGroup1),
      variation: {
        quickpick: 1,
        rounds: 1
      }
    };
    switch (productMapping.getProductId(bet.productId)) {
      case productMapping.CONSTANTS.LOTTO:
        {
          const productName = productMapping.getProductName(bet.productId);
          const day = productMapping.getDay(bet.productId);
          items.push(_objectSpread(_objectSpread({}, item), {}, {
            productName: "".concat(productName, " 1 ").concat(day)
          }));
          if (parseInt(bet.betAmountSalesGroup2, 10)) {
            items.push(_objectSpread(_objectSpread({}, item), {}, {
              productName: "".concat(productName, " 2 ").concat(day)
            }));
          }
          break;
        }
      case productMapping.CONSTANTS.KENO:
        items.push(_objectSpread(_objectSpread({}, item), {}, {
          price: item.price + format.CurrencyFromJupiterString(bet.betAmountSalesGroup2)
        }));
        break;
      default:
        items.push(item);
    }
  });
  return items;
}
function getFund() {
  let product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const state = svs.gamePackage.redux.store.getState();
  switch (product.toUpperCase()) {
    case 'RUBBET':
      return state.numbergames.jackpots.reduce((accumulator, object) => accumulator + object.jackpotAmount, 0);
    default:
      return undefined;
  }
}
function createTransaction(_ref) {
  let {
    items,
    wagerClientSerial,
    wagerAmounts
  } = _ref;
  items = items.map(it => new svs.components.analytics.transactionItem(it.productId, it.productName, it.price, 1, it.variation));
  const price = format.CurrencyFromJupiterString(wagerAmounts.betAmount);
  return new svs.components.analytics.transaction(wagerClientSerial, price, items);
}
function trackPayment(_ref2) {
  let {
    next,
    product,
    price,
    actualPaidPrice,
    successfulWagers
  } = _ref2;
  successfulWagers.forEach(_ref3 => {
    let {
        wager
      } = _ref3,
      args = _objectWithoutProperties(_ref3, _excluded);
    const items = formatItems(wager.bets);
    const trans = createTransaction(_objectSpread({
      items
    }, args));
    svs.components.analytics.trackTransaction(trans);
    svs.gamePackage.logger.debug('Track transaction', trans);
  });
  const fund = getFund(product);
  const {
    wager,
    wagerClientSerial
  } = successfulWagers[0];
  const item = new svs.components.analytics.transactionItem(wager.bagType, product, 0, 1, {
    fund,
    bag: "".concat(price, ":").concat(product, " ").concat(price)
  });
  const trans = new svs.components.analytics.transaction(wagerClientSerial, actualPaidPrice, [item]);
  svs.components.analytics.trackTransaction(trans);
  svs.gamePackage.logger.debug('Track transaction', trans);
  next();
}
svs.gamePackage.pay.trackPayment = trackPayment;

 })(window);